"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

class Newrelic {
  constructor() {
    this.newrelic = window.newrelic;
  }
  /**
   * If newrelic client is available, send the error to newrelic.
   * @param err
   * @param attrs
   */


  noticeError(err, attrs = {}) {
    if (this.newrelic) {
      this.newrelic.noticeError(err, attrs);
    }
  }
  /**
   * Listen for unhandledrejection (unhandled promises) in the
   * browser window and notify newrelic about that event.
   */


  listen() {
    window.addEventListener('unhandledrejection', event => {
      this.noticeError(event.reason);
    });
  }
  /**
   * Notify newrelic about errors on the api calls.
   * Ignore the basic error status for not overloading newrelic with normal errors.
   *
   * @param statusCode
   * @param error
   */


  noticeApiError(statusCode, error) {
    if (![400, 401, 403].includes(Number(statusCode))) {
      this.noticeError(error);
    }
  }

}

var _default = new Newrelic();

exports.default = _default;